import { buildChatUrl } from '@/helper/dishaChatRouteUtils';

/**
 * Resolve a notification click into an in-app route.
 * Supports AiraChat-style deep links: type CHAT_MESSAGE / screen chat → /disha-chat?conversation=
 */
function resolveNotificationRoute(item) {
  if (!item || typeof item !== 'object') return null;

  const data = item.data || item.payload || item.meta || {};
  const type = String(item.type || data.type || data.notificationType || '').toUpperCase();
  const screen = String(data.screen || item.screen || '').toLowerCase();
  const conversationId =
    data.conversationId ||
    data.conversation_id ||
    data.chatId ||
    item.conversationId ||
    null;

  const isChat =
    type === 'CHAT_MESSAGE' ||
    screen === 'chat' ||
    screen === 'disha-chat' ||
    screen === 'dishachat';

  if (isChat) {
    return buildChatUrl({
      conversationId: conversationId || null,
      aiChatActive: !conversationId
    });
  }

  return null;
}

export default resolveNotificationRoute;
